import { Injectable } from '@angular/core';
import { StorageProvider } from '../storage/storage';
import { UserService } from '../auth/user.service';
import { environment } from '../../../../environments/environment';
import { RequestsProvider } from '../requests/requests';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { LoggerFactory } from '../logger/logger-factory.service';
import { PostSitesFavoris, SitesFavorisResponse } from './sites-favoris.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SitesFavorisProvider {
  private logger: LoggerWrapper;
  apiUrl: string = '';

  isSitesLoaded$ = new BehaviorSubject<boolean>(false);

  constructor(
    private userService: UserService,
    private loggerFactory: LoggerFactory,
    private requestsProvider: RequestsProvider,
    private storageProvider: StorageProvider
  ) {
    this.logger = this.loggerFactory.getInstance(this);
    this.apiUrl = environment.apis.API_DACTECH_BACK_V1 + '/favoris';
  }

  async getSitesFavoris(): Promise<Set<string>> {
    let sites: string[] = await this.storageProvider.get(this.getStorageKey(), false);
    if (sites) {
      return new Set<string>(sites);
    } else {
      return new Set<string>();
    }
  }

  updateSitesFavoris(id_sites: string[]) {
    const currentUser = this.userService.getCurrentUser();
    let request: PostSitesFavoris = {
      id_intervenant: currentUser.id,
      id_sites: id_sites,
    };

    this.updateStorage(id_sites).then();
    this.requestsProvider.post(this.apiUrl, request).catch((err) => {
      this.logger.warn('error updateSitesFavoris', err);
    });
  }

  searchSitesFavoris() {
    const currentUser = this.userService.getCurrentUser();
    let url = this.apiUrl + '?id_intervenant=' + currentUser.id;
    this.requestsProvider
      .get(url)
      .then((data: SitesFavorisResponse) => {
        this.updateStorage(data.id_sites).then(() => {
          this.isSitesLoaded$.next(true);
        });
      })
      .catch((err) => {
        this.logger.warn('error searchSitesFavoris', err);
      });
  }

  private getStorageKey(): string {
    const currentUser = this.userService.getCurrentUser();
    return 'starredSites_' + currentUser?.matricule;
  }

  private async updateStorage(id_sites: string[]) {
    await this.storageProvider.set(this.getStorageKey(), id_sites, false);
  }
}
